import * as actionTypes from '../../actions/actionsTypes';
import { updateObject } from '../../utility';

const initialState = {
    loads             : [], 
    totalCount        : 0,
    loading           : false,
    configlist            : [],
    operaterList : [],
    trucks : []
}

const fetchLoadsStart = (state, action) => {
    return updateObject(state, {
        loading       : true,
    });
}

const fetchLoadsSuccess = (state, action) => {
    return updateObject(state, {
        loads        : action.loads,
        totalCount   : action.totalCount                                                                                                              ,
        loading      : false,
    });
}
const fetcSampleFilesSuccess = (state, action) => {
    return updateObject(state, {
        configlist   : action.config,
        loading      : false,
    });
}
const fetchLoadsFail = (state, action) => {
    return updateObject(state, {
        loading     : false,
    })
}
const fetchOperatorListingSuccess =(state, action)=>{
    return updateObject(state, {
        operaterList        : action.operaters,
        totalCount   : action.totalCount                                                                                                              ,
        loading      : false,
    });
}
const fetchTrucksListingSuccess =(state, action)=>{
    return updateObject(state, {
        trucks        : action.Trucks,
        totalCount   : action.totalCount                                                                                                              ,
        loading      : false,
    });
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_LOADS_START             : return fetchLoadsStart(state, action);
        case actionTypes.FETCH_LOADS_SUCCESS           : return fetchLoadsSuccess(state, action);
        case actionTypes.FETCH_LOADS_FAIL              : return fetchLoadsFail(state, action);
        case actionTypes.FETCH_CONFIG_SUCCESS           : return fetcSampleFilesSuccess(state, action)
        case actionTypes.FETCH_OPERATORLISTING_LOAD_SUCCESS : return fetchOperatorListingSuccess(state, action);
        case actionTypes.FETCH_TRUCKLISTING_LOAD_SUCCESS : return fetchTrucksListingSuccess(state, action)
        default: return state;
    }
}

export default reducer;